import { ConnectionError } from '../app/errors';

const voucherUrl = `${api_config.bet_tracker_api}/vouchers/`;

// eslint-disable-next-line import/prefer-default-export
export const getFreeBets = () => fetch(voucherUrl, {
  method: 'GET',
  credentials: 'include',
  cache: 'no-cache'
})
  .catch(e => {
    throw new ConnectionError(e.message);
  })
  .then(response => {
    const { status, statusText } = response;

    if (status === 200) {
      return response;
    }

    throw new ConnectionError(statusText, status);
  })
  .then(response => ((response.status === 200) ? response.json() : response));
